import { render, staticRenderFns } from "./MaterialRecommendation.vue?vue&type=template&id=68847753&scoped=true&"
import script from "./MaterialRecommendation.vue?vue&type=script&lang=js&"
export * from "./MaterialRecommendation.vue?vue&type=script&lang=js&"
import style0 from "./MaterialRecommendation.vue?vue&type=style&index=0&id=68847753&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68847753",
  null
  
)

export default component.exports